export enum UserRoles {
  USERMANAGER = 'USERMANAGER',
  USER = 'USER',
  DOCTOR = 'DOCTOR',
  NURSE = 'NURSE',
  PHYSICALTHERAPIST = 'PHYSICALTHERAPIST',
  LABTECH = 'LABTECH',
  SYSADMIN = 'SYSADMIN',
  PATIENT = 'PATIENT',
  PHARMACIST = 'PHARMACIST',
  INVENTORYMANAGER = 'INVENTORYMANAGER'
}

export const userRoleArray: string[] = [
  'USERMANAGER',
  'USER',
  'DOCTOR',
  'NURSE',
  'PHYSICALTHERAPIST',
  'LABTECH',
  'SYSADMIN',
  'PATIENT'
];

export interface IUser {
  _id?: string;
  username: string;
  password: string;
  firstname: string;
  lastname: string;
  emails: string;
  organization: string;
  roles?: UserRoles[];
  phoneNumbers?: string[];
  additionalProperties?: any;
  profilePictureId: string;
  authItems: any[];
}

export enum UserSearchAction {
  LINKUSERTOPATIENT = 'LINKUSERTOPATIENT'
}
